<template>
  <div class="animated fadeIn">
    <h4 class="page-title">User States</h4>
    <hr />
    <div class="row">
      <div class="col">
        <div style="margin: 0 auto; width: 10px;" v-if="isFetching">
          <div class="loader-dark-blue medium mb-5 mt-5"></div>
        </div>
        <div class="mb-3" v-show="!isFetching">
          <span v-show="items.length">Number of data found: <b-badge pill variant="primary">{{items.length}}</b-badge></span>
          <b-btn class="float-right" variant="primary" size="sm" @click="add()"><i class="fa fa-plus"></i> Add</b-btn>
        </div>
        <b-alert variant="danger"
          class="text-center"
          :show="!isFetching && !items.length">
          Data is empty
        </b-alert>
        <b-table responsive hover striped :fields="fields" :items="items" :per-page="itemsPerPage" :current-page="currentPage" v-show="!isFetching && items.length">
          <template slot="STATUS" slot-scope="row">
            <span class="badge badge-sm" v-bind:class="{'badge-success': row.value, 'badge-danger': !row.value}">{{row.value ? 'ACTIVE' : 'INACTIVE'}}</span>
          </template>
        </b-table>
        <b-pagination v-show="items.length > 10" :total-rows="items.length" :per-page="itemsPerPage" v-model="currentPage" />
      </div>
    </div>
  </div>
</template>
<script>
import { server, fieldsService } from '@/services/'
import { UserStatesModal } from '@/components/modals/'
import { mapState } from 'vuex'

export default {
  name: 'user-states',
  data () {
    return {
      errorMsg: Object,
      itemsPerPage: 10,
      currentPage: 1,
      itemsCount: 0,
      fields: fieldsService.USER_STATES
    }
  },
  computed: {
    ...mapState('userState', {
      items: state => state.items,
      isFetching: state => state.isFetching
    })
  },
  created () {
    this.$store.commit('userState/setIsFetching', true)
    this.$store.cache.dispatch('userState/getAll').then(
      resp => {
        this.$store.commit('userState/setIsFetching', false)
      }
    )
  }
}
</script>
